import { useState } from 'react'
import './Rating.css'

function Rating({ value = 0, onChange, readonly = false, size = 'md', showValue = true }) {
  const [hoverValue, setHoverValue] = useState(0)
  
  const handleClick = (rating) => {
    if (!readonly && onChange) {
      onChange(rating)
    }
  }

  const handleMouseEnter = (rating) => {
    if (!readonly) {
      setHoverValue(rating)
    }
  }

  const handleMouseLeave = () => {
    if (!readonly) {
      setHoverValue(0)
    }
  }

  const displayValue = hoverValue || value

  return (
    <div className={`rating rating-${size} ${readonly ? 'readonly' : ''}`}>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((rating) => (
          <button
            key={rating}
            type="button"
            className={`star-btn ${rating <= displayValue ? 'filled' : ''}`}
            onClick={() => handleClick(rating)}
            onMouseEnter={() => handleMouseEnter(rating)}
            onMouseLeave={handleMouseLeave}
            disabled={readonly}
            aria-label={`Rate ${rating} stars`}
          >
            <svg viewBox="0 0 24 24" className="star-icon">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </button>
        ))}
      </div>
      {showValue && value > 0 && (
        <span className="rating-value">{value}/5</span>
      )}
    </div>
  )
}

export default Rating
